import React, { Component } from "react"
import { leaveEmpty, one2five, noMaybeYes } from '../../variables/ComboValues'
import { updateElement } from "../Tree/Utils.js"
import { InputF, TextareaF, SelectF } from '../../elements/FormFields'

//import { digmaDate, searchTableFilter } from "./Utils.js"
//import { EditableCell } from "../TableList/EditableCell"

// input (props) 
//      tableTitle={"תוכנית עבודה"}
//      familyCode - TBD
// Resources: see import above

// TODO: get data from DB && Update to DB
export const  RightsQ_microLegend = {
    "rights_intro": "מיצוי זכויות",
    "rights_extent": "באיזו מידה אתם משיגים את הזכויות שלכם?",
    "rights_q1": "ביטוח לאומי",
    "rights_q2": "מעונות יום / משפחתונים",
    "rights_q3": "תשלומים למועצה המקומית (ארנונה, מים ועוד)",
    "rights_q4": "חברת החשמל",
    "rights_q5": "בריאות",
    "rights_q6": "שיכון",
    "rights_q7": "חינוך ילדים",
    "rights_q8": "בנקים",
    "rights_q9": "אחר",
    "rights_assistance": "האם אתם מעוניינים בסיוע כדי לממש את הזכויות שלכם?",
    "comments": "הערות"
}

export class FamilyRightsQ extends Component {

    constructor(props) {
      super(props)
      this.state = { products: this.props.data }
      this.onSaveTable = this.onSaveTable.bind(this)
      this.handleProductTable = this.handleProductTable.bind(this)
    }
    
    handleProductTable(evt) {
        evt.preventDefault()
        var newp= updateElement(evt, this.state.products)
        this.setState({products:newp})
    }

    // update data base
    onSaveTable(evt) {
      evt.preventDefault()
      const { save2DB, subTableId, familyPostId, inUpdate, mbouser } = this.props
      // console.log("Family General save table: products", this.state.products)
      save2DB(familyPostId, this.state.products, subTableId, "group", inUpdate, mbouser )
    }
    render() {
      const {tableTitle} = this.props
      // const { data } = this.props
      //console.log("Family general this.state.products=", this.state.products)
      // console.log("OLD meeting data", this.state.products)
      
      return (
          <ProductTable 
            onProductTableUpdate={this.handleProductTable}
            onSaveTable={this.onSaveTable} 
            headerColumns = {[ "need_legal", "legal_explain" ]}
            tableTitle = {tableTitle} 
            products={this.state.products} 
          />
      )
    }
  }
  /*   class SearchBar extends Component { moved to file */
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
            filterText : ""
        }
    }
    
    handleUserInput(filterText) {
        this.setState({filterText: filterText});
    }
    render() {
      const { onProductTableUpdate, products, tableTitle, onSaveTable } = this.props
      //var buttonStyle = {marginRight: '0'}
      // console.log("General - products", products)
      
      var product = ""
      var cellData = []
      if (typeof products !== "undefined"){
          product = products
          cellData=[{
            type: "textarea",
            name: "rights_intro",
            value: product.rights_intro,
            id: product.id,
            style: {width: "400px"},
            edit: true
          },{
            type: "select",
            options: one2five, // ["1- כלל לא","2","3","4","5- במידה רבה מאוד"],
            name: "rights_extent",
            value: product.rights_extent,
            id: product.id,
            style: {width: "400px"},
            edit: true
          },{
            newsection: "באלו תחומים אתם מרגישים צורך לממש את הזכויות שלכם?",
            type: "text",
            placeholder: leaveEmpty, // "לא מעוניינים- להשאיר ריק",
            //options: ["לא","כן"],
            name: "rights_q1",
            value: product.rights_q1,
            id: product.id,
            style: {width: "400px"},
            edit: true
          },{
            type: "text",
            placeholder: leaveEmpty, // "לא מעוניינים- להשאיר ריק",
            //options: ["לא","כן"],
            name: "rights_q2",
            value: product.rights_q2,
            id: product.id,
            style: {width: "400px"},
            edit: true
          },{
            type: "text",
            placeholder: leaveEmpty, // "לא מעוניינים- להשאיר ריק",
            //options: ["לא","כן"],
            name: "rights_q3",
            value: product.rights_q3,
            id: product.id,
            style: {width: "400px"},
            edit: true
          },{
            type: "text",
            placeholder: leaveEmpty, // "לא מעוניינים- להשאיר ריק",
            //options: ["לא","כן"],
            name: "rights_q4",
            value: product.rights_q4,
            id: product.id,
            style: {width: "400px"},
            edit: true
          },{
            type: "text",
            placeholder: leaveEmpty, // "לא מעוניינים- להשאיר ריק",
            //options: ["לא","כן"],
            name: "rights_q5",
            value: product.rights_q5,
            id: product.id,
            style: {width: "400px"},
            edit: true
          },{
            type: "text",
            placeholder: leaveEmpty, // "לא מעוניינים- להשאיר ריק",
            //options: ["לא","כן"],
            name: "rights_q6",
            value: product.rights_q6,
            id: product.id,
            style: {width: "400px"},
            edit: true
          },{
            type: "text",
            placeholder: leaveEmpty, // "לא מעוניינים- להשאיר ריק",
            //options: ["לא","כן"],
            name: "rights_q7",
            value: product.rights_q7,
            id: product.id,
            style: {width: "400px"},
            edit: true
          },{
            type: "text",
            placeholder: leaveEmpty, // "לא מעוניינים- להשאיר ריק",
            //options: ["לא","כן"],
            name: "rights_q8",
            value: product.rights_q8,
            id: product.id,
            style: {width: "400px"},
            edit: true
          },{
            type: "textarea",
            name: "rights_q9",
            value: product.rights_q9,
            id: product.id,
            style: {width: "400px"},
            edit: true
          },{
            type: "select",
            options: noMaybeYes, // ["לא","אולי","כן"],
            name: "rights_assistance",
            value: product.rights_assistance,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            type: "textarea",
            name: "comments",
            value: product.comments,
            id: product.id,
            style: {width: "400px"},
            edit: true
          }]  

      }
      return (
        <div className="yahav-modal">
            {<h2 className="sub-tab-title">{tableTitle}</h2>}
            
            <button type="button"  className="btn btn-success pull-left update-button" onClick={onSaveTable}>עדכון</button>
            
            <div className="mynewdivform width1140">
                <ProductRow 
                    onProductTableUpdate={onProductTableUpdate} 
                    product={product} 
                    cd={cellData}
                    />
            </div>
        </div>
      )
    }
  }

class ProductRow extends Component {
    
    render() {
      const {onProductTableUpdate, cd} = this.props
      var key = 0;
      if (cd === "undefined" || !cd.length)
        return (<h4>קבוצת השדות לא מוגדרות במאגר המידע<br/>כנראה בעיה במעבר מאינטייק למשפחה</h4>)
    //console.log("ProductRow = cd=", cd)
      return (
        <div className="eachRow" >
        {cd.map(cellInfo => {
            if (typeof cellInfo.newsection !== "undefined")
              return(
              <React.Fragment key={key++}>
                <h3 key={key++} >{cellInfo.newsection}</h3>
                <EditableFormCell key={key++} onProductTableUpdate={onProductTableUpdate} cellData={cellInfo} />
              </React.Fragment>
              )
            return (<EditableFormCell key={key++} onProductTableUpdate={onProductTableUpdate} cellData={cellInfo} /> )
        })}
        </div>
      )
  
    }
  
  }
  
  class EditableFormCell extends Component {
    render() {
        const tp = this.props
        const tpc = tp.cellData
        if (tpc.type === "select"){
          return(
            <div className="form-cell-box">
              <label style={{ width: '35%'}} htmlFor={tpc.id}>{RightsQ_microLegend[tpc.name]}</label>
              <SelectF tp={tp} tpc={tpc} overstyle={{ display: 'inline-block', verticalAlign : 'top'}} />
              {/*<select style={{display: 'inline-block', verticalAlign : 'top'}} name={tpc.name} id={tpc.id} value={tpc.value} onChange={tp.onProductTableUpdate} > 
                <option key={1111111} value="נא לבחור" > נא לבחור </option>
                {
                tpc.options.map(item => {
                    // let i =  Math.floor(Math.random(Date()) * 8386560)  // ID10000000 // // 
                    return(<option key={item} value={item}>{item}</option>)
                    })
                }
              </select>*/}
            </div>
          )
        }
        if (tpc.type === "textarea"){
          return(
            <div className="form-cell-box">
              <label style={{ width: '35%', display: 'inline-block', verticalAlign : 'top'}} htmlFor={tpc.id}>{RightsQ_microLegend[tpc.name]}</label>
              <TextareaF tp={tp} tpc={tpc} overstyle={{ width:'400px', display: 'inline-block'}} />
              {/* tpc.edit ? 
                <textarea style={{ width:'400px', display: 'inline-block'}} name={tpc.name} id={tpc.id} 
                    value={tpc.value} onChange={tp.onProductTableUpdate}
                /> :
                <textarea style={{ width:'400px', display: 'inline-block', verticalAlign : 'top'}} name={tpc.name} id={tpc.id} value={tpc.value} />
              */}
            </div>
          )
        }
        return (
          <div className="form-cell-box">
            <label style={{ width: '35%'}} htmlFor={tpc.id}>{RightsQ_microLegend[tpc.name]}</label>
            <InputF tp={tp} tpc={tpc} />

              {/*tpc.edit  ? 
                <input style={tpc.style} type={tpc.type} name={tpc.name} id={tpc.id} 
                        value={tpc.value} 
                        placeholder={tpc.placeholder === undefined ? "" : tpc.placeholder} 
                        onChange={tp.onProductTableUpdate}
                    /> : 
                    <input style={tpc.style} type={tpc.type} name={tpc.name} id={tpc.id} 
                        value={tpc.value} 
                        placeholder= {tpc.placeholder === undefined ? "" : tpc.placeholder} 
                        onChange={tp.onProductTableUpdate} disabled
                        />
              */}
            </div>
        )
  
    }
  }
